// extracted by mini-css-extract-plugin
export default {"select-input":"select-input-EfTtl"};